<template>
	<component
		:is="tag"
		:type="actionless ? undefined : 'button'"
		:disabled="disabled"
		class="group flex items-center px-md py-sm text-left"
		:class="{
			'bg-gray-100 text-gray-500': disabled,
		}"
	>
		<!-- Preserve fixed size to prevent cls before icon is loaded -->
		<span
			class="mr-sm inline-flex size-sm shrink-0 items-center justify-center"
		>
			<v-icon :icon="icon"></v-icon>
		</span>

		<span
			class="text-sm tracking-xl"
			:class="{
				'group-hover:underline': !actionless && !disabled,
			}"
		>
			<slot></slot>
		</span>

		<v-icon
			v-if="!actionless"
			icon="chevron-right"
			class="ml-auto text-xl"
		></v-icon>
	</component>
</template>

<script lang="ts" setup>
import type {Icon} from "@pkg/shared/types";

const properties = defineProps<{
	icon: Icon;
	actionless?: boolean;
	disabled?: boolean;
}>();

const tag = computed(() => {
	if (properties.actionless) {
		return "div";
	}

	return "button";
});
</script>
